import { a as _objectSpread2 } from '../_rollupPluginBabelHelpers-1f0bf8c2.js';
import { createComponent } from 'reakit-system/createComponent';
import { createHook } from 'reakit-system/createHook';
import 'reakit-utils/shallowEqual';
import { useBox } from '../Box/Box.js';
import 'react';
import 'reakit-utils/useLiveRef';
import 'reakit-utils/useSealedState';
import '../Id/IdProvider.js';
import '../Id/IdState.js';
import 'reakit-utils/useUpdateEffect';
import 'reakit-utils/isPromise';
import 'reakit-utils/isEmpty';
import 'reakit-utils/isPlainObject';
import { unstable_useFormState } from './FormState.js';
import 'reakit-utils/isObject';
import './utils/setAllIn.js';
import { unstable_getIn } from './utils/getIn.js';
import 'reakit-utils/toArray';
import 'reakit-utils/isInteger';
import './utils/setIn.js';
import '../getInputId-aa144169.js';
import { s as shouldShowError, g as getMessageId } from '../shouldShowError-62b18bba.js';

function shouldShowMessage(_ref, name) {
  var touched = _ref.touched,
      messages = _ref.messages;
  return !!(unstable_getIn(touched, name) && unstable_getIn(messages, name));
}

var unstable_useFormMessage = createHook({
  name: "FormMessage",
  compose: useBox,
  useState: unstable_useFormState,
  keys: ["name"],
  useProps: function useProps(options, htmlProps) {
    var children = shouldShowError(options, options.name) ? unstable_getIn(options.errors, options.name) : undefined;
    children = children || (shouldShowMessage(options, options.name) ? unstable_getIn(options.messages, options.name) : undefined);
    return _objectSpread2({
      role: "alert",
      id: getMessageId(options.name, options.baseId),
      children: children
    }, htmlProps);
  }
});
var unstable_FormMessage = createComponent({
  as: "div",
  memo: true,
  useHook: unstable_useFormMessage
});

export { unstable_FormMessage, unstable_useFormMessage };
